export const VARIANT_URGENCY_QUANTITY_CRITERIA = 10;
export const VARIANT_URGENCY_THRESHOLD = 10;
export const VARIANT_UREGNCY_RATIO = 2; // IF MORE THAN HALF OR MORE MEETS CRITERIA
